export const FACTORAJE_MEGA_CLICK = 'factoraje';
export const FACTORAJE_EJERCER = 'factorajeejercer';
export const CREDITO_PERSONA_MORAL = 'creditopersonamoral';
export const FLOW_VIVIENDA = '/vivienda';
export const FLOW_INMOBILIARIA = '/inmobiliaria';
